module.exports = __webpack_public_path__ + "static/img/1-1.e360643.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/3/1/1-1.png
// module id = jwqn
// module chunks = 0